import { onMounted, onUnmounted } from 'vue-demi';

// when back button triggers iframe popstate
// see: https://stackoverflow.com/questions/60549567/chrome-80-duplicating-history-entries-if-iframe-present-on-page
export default function usePopState({ w = window, isLegacyConnected = false }) {
  if (!isLegacyConnected) {
    return;
  }

  // because iframes cause duplicate entries in the history stack.
  const popState = () => {
    w.history.back(-2);
  };

  onMounted(() => {
    w.addEventListener('popstate', popState);
  });

  onUnmounted(() => {
    w.removeEventListener('popstate', popState);
  });
}
